/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyTagCreateUpdateRequest } from '../../models/company-tag-create-update-request';
import { CompanyTagDto } from '../../models/company-tag-dto';

export interface UpdateCompanyTag$Params {
  id: number;
      body: CompanyTagCreateUpdateRequest
}

export function updateCompanyTag(http: HttpClient, rootUrl: string, params: UpdateCompanyTag$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyTagDto>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyTag.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyTagDto>;
    })
  );
}

updateCompanyTag.PATH = '/api/company/tags/{id}';
